import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://reg.swimsport.ru/api',//'http://swim.loc/api'
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    }
});

// Добавляем токен к каждому запросу
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

// Обрабатываем 401 ошибку
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            window.location.href = '/loginsw';
        }
        return Promise.reject(error);
    }
);

export const getDistances = (gender) => api.get(`/distances?gender=${gender}`);
export const getRegistrationsGroupedByDistance = () => api.get(`/distances/registrations`);
export const getSwimmers = (hash) => api.get(`/registration?hash=${hash}`);
export const registerSwimmer = (data) => api.post('/swimmers', data);

export default api;
